import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography, TextField, IconButton } from '@mui/material';
import { Formik, Form } from 'formik';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import { phoneNumberSchema, codeNumberSchema, passValidationSchema } from '../../StaticData/index';
import { useSendSms, useCheckForgetCode, useAddNewPassWord } from '../../Hooks';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LockResetIcon from '@mui/icons-material/LockReset';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';

const ResetPassword = (props: any) => {
  // const [statusCheckCode, setStatusCheckCode] = useState<boolean | null>(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [userPhoneNumber, setUserPhoneNumber] = useState<string>('');
  const [content, setContent] = useState<string>('getPhoneNumber');
  const [contentMessage, setContentMessage] = useState<string>('لطفا شماره همراه خود را وارد نمایید');

  const { setContentState } = props;

  const initialCancel = () => {
    setContentState({ content: 'login' });
  };

  const { mutate: callAddNewPassWord, data: addNewPassWordData, isLoading: addPassLoad } = useAddNewPassWord(() => {
    setToastMessage('عملیات با موفقیت انجام شد');
    setShowToastMessage(true);
    setTimeout(() => setContentState({ content: 'login' }), 2000); // هدایت به صفحه ورود بعد از 2 ثانیه
  });

  const { mutate: sendSms, isLoading: sendSmsLoading, data: sendSmsData } = useSendSms(() => {
    setContent('enterCode');
  });

  const { mutate: checkCode, isLoading: checkCodeLoading, data: checkCodeData } = useCheckForgetCode();

  useEffect(() => {
    switch (content) {
      case 'enterCode':
        setContentMessage('کد دریافتی را وارد کنید');
        break;
      case 'enterNewPassword':
        setContentMessage('رمز جدید خود را وارد کنید');
        break;
      default:
        setContentMessage('لطفا شماره همراه خود را وارد نمایید');
    }
  }, [content]);

  useEffect(() => {
    if (checkCodeData) {
      let { data } = checkCodeData;
      if (data) {
        setContent('enterNewPassword');
      } else {
        setToastMessage('کد وارد شده اشتباه است');
        setShowToastMessage(true);
      }
    }
  }, [checkCodeData]);

  useEffect(() => {
    if (sendSmsData) {
      let { data } = sendSmsData;
      let { status, message } = data;
      if (status !== 10) {
        setContent('enterCode');
      } else {
        setContent('getPhoneNumber');
        setToastMessage(data?.message);
        setShowToastMessage(true);
      }
    }
  }, [sendSmsData]);

  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const renderContent = () => {
    switch (content) {
      case 'getPhoneNumber':
        return (
          <Formik
            enableReinitialize
            validationSchema={phoneNumberSchema}
            initialValues={{ phoneNumber: '', smsType: 'Forget' }}
            onSubmit={(data: any) => {
              let { phoneNumber } = data;
              setUserPhoneNumber(phoneNumber);
              sendSms(data);
            }}
          >
            {({ values, dirty, isValid }) => (
              <Form>
                <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <FormikControl
                      control='textField'
                      label='شماره تلفن'
                      name='phoneNumber'
                      fullWidth
                      value={values.phoneNumber || ''}
                    />
                  </Grid>
                  <Grid item xs={6} flexGrow={1} mx={'auto'}>
                    <Box>
                      <DyButton
                        caption={'دریافت کد'}
                        color={'#00387C'}
                        onClick={() => { }}
                        disabled={!isValid || !dirty || sendSmsLoading}
                        variant={'contained'}
                        bgColor={'#00387C'}
                        type={'submit'}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        );
      case 'enterCode':
        return (
          <Formik
            enableReinitialize
            validationSchema={codeNumberSchema}
            initialValues={{ phoneNumber: userPhoneNumber, code: '' }}
            onSubmit={(data: any) => {
              checkCode(data);
            }}
          >
            {({ values, dirty, setFieldValue, isValid }) => (
              <Form>
                <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box sx={{ padding: '8px' }}>
                      <TextField
                        fullWidth
                        size='small'
                        value={values.code}
                        onChange={({ target }: any) => {
                          let { value }: any = target;
                          setFieldValue('code', value);
                        }}
                        label={'کد دریافتی'}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6} flexGrow={1} mx={'auto'}>
                    <Box>
                      <DyButton
                        caption={'تایید و ادامه'}
                        color={'#00387C'}
                        onClick={() => { }}
                        disabled={checkCodeLoading || !isValid || !dirty}
                        variant={'contained'}
                        bgColor={'#00387C'}
                        type={'submit'}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        );
      case 'enterNewPassword':
        return (
          <Formik
            enableReinitialize
            validationSchema={passValidationSchema}
            initialValues={{ phoneNumber: userPhoneNumber, newPassword: '', confirmNewPassword: '' }}
            onSubmit={(data: any) => {
              callAddNewPassWord(data);
            }}
          >
            {({ values, dirty, setFieldValue, isValid }) => (
              <Form>
                <Grid container columnSpacing={1} xs={10} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box>
                      <FormikControl
                        control="textField"
                        name="newPassword"
                        type={showPassword1 ? 'text' : 'password'}
                        fullWidth
                        size="small"
                        value={values.newPassword}
                        onChange={({ target }: any) => {
                          let { value }: any = target;
                          setFieldValue('newPassword', value);
                        }}
                        label={'رمز عبور جدید'}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={handleClickShowPassword1}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword1 ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={7} mx={'auto'}>
                    <Box>
                      <FormikControl
                        control="textField"
                        name="confirmPassword"
                        type={showPassword2 ? 'text' : 'password'}
                        fullWidth
                        size="small"
                        value={values.confirmNewPassword}
                        onChange={({ target }: any) => {
                          let { value }: any = target;
                          setFieldValue('confirmNewPassword', value);
                        }}
                        label={'تکرار رمز عبور جدید'}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword2 ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6} flexGrow={1} mx={'auto'}>
                    <Box>
                      <DyButton
                        caption={'تایید'}
                        color={'#00387C'}
                        onClick={() => { }}
                        disabled={addPassLoad || !isValid || !dirty}
                        variant={'contained'}
                        bgColor={'#00387C'}
                        type={'submit'}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        );
      default:
        return null;
    }
  };

  return (
    <Grid container>
      <Grid item xs={8} mx={'auto'}>
        <Box py={3} display={'flex'} justifyContent={'space-between'} alignItems={'center'} columnGap={2}>
          <Typography variant='body1' fontWeight={600}>
            لطفا اطلاعات مورد نیاز را وارد نمایید
          </Typography>
          <LockResetIcon fontSize='large' />
          <IconButton onClick={initialCancel}>
            <ArrowForwardIcon />
            <Typography> برگشت </Typography>
          </IconButton>
        </Box>
      </Grid>
      <Grid item xs={12}>
        {renderContent()}
      </Grid>
      {(showToastMessage && toastMessage) && (
        <DYToastMessage
          show={showToastMessage}
          setShow={setShowToastMessage}
          message={toastMessage}
          isSuccess={toastMessage === 'عملیات با موفقیت انجام شد'} // تعیین وضعیت موفقیت
        />
      )}
    </Grid>
  );
};

export default ResetPassword;





// import React, { useState,useEffect } from 'react';
// import { Grid, Box, Typography,TextField, IconButton } from '@mui/material';
// import { Formik, Form } from 'formik';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
// import FormikControl from '../../../../components/FormikControls/FormikControl';
// import {phoneNumberSchema,codeNumberSchema,passValidationSchema} from '../../StaticData/index'
// import { useSendSms,useCheckForgetCode,useAddNewPassWord } from '../../Hooks';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import LockResetIcon from '@mui/icons-material/LockReset';
// import InputAdornment from '@mui/material/InputAdornment';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff'
// import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';

// const ResetPassword = (props: any) => {
//   const [StatusCheckCode,setStatusCheckCode]=useState<boolean|null>(false)
// const sucessSendSms=()=>{
         
//   // if (sendSmsData) {

//   //   let{data}=sendSmsData;
//   //   if (data) {
//   //     setContent('enterCode')
//   //   }
//   //   else{
//   //     setContentMessage('')
//   //   }
   
//   // }

//   // if (true) {
//   //   setContent('enterCode')
//   // }
// }

// // const successCheckForgetCode=()=>{
// //   if (StatusCheckCode) {
// //     setContent('enterNewPassword')
// //   } else {
// //        setContentMessage('کد وارد شده اشتباه است')
// //        setTimeout(() => {
// //         setStatusCheckCode(true)
// //        }, 1000);
// //   }

// // }
// const [showPassword1, setShowPassword1] = React.useState(false);
// const [showPassword2, setShowPassword2] = React.useState(false);

// const handleClickShowPassword = () => setShowPassword1((show) => !show);
// const sucessForgetPassword=()=>{
//   setContentState({ content: 'login' })
// }

//   const{mutate:callAddNewPassWord,data:AddNewPassWordData,isLoading:addPassLoad}=useAddNewPassWord(sucessForgetPassword)
//   const{mutate:sendSms,isLoading:sendSmsLoading,data:sendSmsData}=useSendSms(sucessSendSms);
//   const{mutate:checkCode,isLoading:checkCodeLoading,data:checkCodeData}=useCheckForgetCode();
//   // const{mutata:callAddNewPassWord,isLoading:addPassLoading,data:addPassData}=useForgetPassword(sucessForgetPassword)
//   const [showPassword, setShowPassword] = React.useState(false);
//   const [showToastMessage,setShowToastMessage]=useState<boolean>(false)

//   // const handleClickShowPassword = () => setShowPassword((show) => !show);

//   const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
//     event.preventDefault();
//   };
//   const[userPhoneNumber,setUserPhoneNumber]=useState<string>('')
//   const [content, setContent] = useState<string>('getPhoneNumber');
//   const [contentMessage, setContentMessage] = useState<string>('لطفا شماره همراه خود را وارد نمایید')

//   let { setContentState } = props;

//   const initialCancel = () => {
//     setContentState({ content: 'login' })
//   };

//   useEffect(() => {
//    switch (content) {
//     case 'enterCode':
//       setContentMessage('کد دریافتی را وارد کنید')
//       break;

//       case 'enterNewPassword':
//         setContentMessage('رمز جدید خود را وارد کنید')
//         break;
//    }
//   }, [content])

//   useEffect(() => {

//     if (checkCodeData) {
//       let{data}=checkCodeData;
//       if (data) {
//         setContent('enterNewPassword')
//       }
//       else{
//         setContentMessage('کد وارد شده اشتباه است')
//         setShowToastMessage(true)

//       }
//     }
//   }, [checkCodeData])
 
//   useEffect(() => {

//     if (sendSmsData) {
//       let{data}=sendSmsData;
//       let{status,message}=data;
//       if (status !== 10) {
//         setContent('enterCode')
//       }
//       else{
//         setContentMessage(message)
//         setShowToastMessage(true)

//       }
//     }
//   }, [sendSmsData])
 
//   const renderContent = () => {
//     switch (content) {
//       case 'getPhoneNumber':
//         return <Formik
//         enableReinitialize
//         validationSchema={phoneNumberSchema}
//         initialValues={{ phoneNumber: '',smsType:'Forget' }}
//           onSubmit={(data: any) => {
//             let{phoneNumber}=data;
//             setUserPhoneNumber(phoneNumber);
//             sendSms(data)
//           }}
//         >
//           {
//             ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
//               <Form>
//                 <Grid container columnSpacing={1}
//                   sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}   >


//                   <Grid item xs={7} flexGrow={1} mx={'auto'}  >
//                     <FormikControl
//                       control='textField'
//                       label='شماره تلفن'
//                       name='phoneNumber'
//                       fullWidth
//                       value={values.phoneNumber || ''}
//                     />
//                   </Grid>

//                   <Grid item xs={6} flexGrow={1} mx={'auto'}>
//                     <Box >
//                       <DyButton
//                         caption={'دریافت کد'}
//                         color={'#00387C'}
//                         onClick={() => { }}
//                         disabled={!isValid || !dirty || sendSmsLoading}
//                         variant={'contained'}
//                         bgColor={'#00387C'}
//                         type={'submit'}
//                       />
//                     </Box>
//                   </Grid>
//                 </Grid>


//               </Form>
//           }

//         </Formik>
//         break;

//         case 'enterCode':
//           return <Formik
//           enableReinitialize
//           validationSchema={codeNumberSchema}
//           initialValues={{phoneNumber:userPhoneNumber,code:'' }}
//           onSubmit={(data: any) => {
//             checkCode(data)
//           console.log(data)
//           }}
//         >
//           {
//             ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
//               <Form>
//                 <Grid container columnSpacing={1}
//                   sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}   >


//                   <Grid item xs={7} flexGrow={1} mx={'auto'}  >
//                       <Box  sx={{padding:'8px'}}  >
//                      <TextField
//                         fullWidth
//                         size='small'                    
//                         value={values.code}
//                         onChange={({target}:any)=>{
//                           let{value}:any=target;
//                           setFieldValue('code',value)
//                           // initialSetHunderdvalue(value)
//                         }}
//                         label={'کد دریافتی'}   />
//                      </Box>
//                   </Grid>

//                   <Grid item xs={6} flexGrow={1} mx={'auto'}>
//                     <Box >
//                       <DyButton
//                         caption={'تایید و ادامه'}
//                         color={'#00387C'}
//                         onClick={() => { }}
//                         disabled={checkCodeLoading || !isValid || !dirty  }
//                         variant={'contained'}
//                         bgColor={'#00387C'}
//                         type={'submit'}
//                       />
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Form>
//           }
//         </Formik>
//         break;
       
//         case 'enterNewPassword':
//           return <Formik
//           enableReinitialize
//           validationSchema={passValidationSchema}
//           initialValues={{phoneNumber:userPhoneNumber,newPassword:'',confirmNewPassword:'' }}
//           onSubmit={(data: any) => {
//             callAddNewPassWord(data)
//           }}
//         >
//           {
//             ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
//               <Form>
//                 <Grid container columnSpacing={1} xs={10}
//                   sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}   >
//                   <Grid item xs={7} flexGrow={1} mx={'auto'}  >
//                       {/* <Box  sx={{padding:'8px'}}  >
//                      <TextField
//                         fullWidth
//                         size='small'
//                         type={showPassword ? 'text' : 'password'}                    
//                         value={values.newPassword}
//                         onChange={({target}:any)=>{
//                           let{value}:any=target;
//                           setFieldValue('newPassword',value)
//                           // initialSetHunderdvalue(value)
//                         }}
//                         label={'رمز عبور جدید'}   />
//                      </Box>
//                   </Grid>

//                   <Grid item xs={7} flexGrow={1} mx={'auto'}  >
//                     <Box  sx={{padding:'8px'}}  >
//                     <TextField
//                       type={showPassword ? 'text' : 'password'}
//                       fullWidth
//                       size='small'                    
//                       value={values.confirmNewPassword}
//                       onChange={({target}:any)=>{
//                         let{value}:any=target;
//                         setFieldValue('confirmNewPassword',value)
//                         // initialSetHunderdvalue(value)
//                       }}
//                       label={'تکرار رمز عبور جدید'}   />
//                      <InputAdornment position="end">
//                      <IconButton
//                      size="medium"
//                      color="primary"
//                      onClick={handleClickShowPassword}
//                      onMouseDown={handleMouseDownPassword}
//                      edge="end"
//                       >
//                   {showPassword ? <VisibilityOff /> : <Visibility />}
//                 </IconButton>
//               </InputAdornment>
//                     </Box>
//                 </Grid> */}
//                 <Box    >
//                  <FormikControl
//       control="textField"
//       name="password"
//       type={showPassword1 ? 'text' : 'password'}
//       fullWidth
//       size="small"
//       value={values.newPassword}
//       onChange={({ target }: any) => {
//         let { value }: any = target;
//         setFieldValue('newPassword', value);
//       }}
//       label={'رمز عبور جدید'}
//       InputProps={{
//         endAdornment: (
//           <InputAdornment position="end">
//             <IconButton
//               size="small"
//               color="primary"
//               onClick={() => setShowPassword1(!showPassword1)}
//               onMouseDown={handleMouseDownPassword}
//             >
//               {showPassword1 ? <VisibilityOff /> : <Visibility />}
//             </IconButton>
//           </InputAdornment>
//         ),
//       }}
//     />
//   </Box>
// </Grid>

// <Grid item xs={7} mx={'auto'}>
//   <Box>
//     {/* <div className="error">
//       <ErrorMessage name="confirmPassword" />
//     </div> */}
//     <FormikControl
//       control="textField"
//       name="confirmPassword"
//       type={showPassword2 ? 'text' : 'password'}
//       fullWidth
//       size="small"
//       value={values.confirmNewPassword}      onChange={({ target }: any) => {
//         let { value }: any = target;
//         setFieldValue('confirmNewPassword', value);
//       }}
//       label={'تکرار رمز عبور جدید'}
//       InputProps={{
//         endAdornment: (
//           <InputAdornment position="end">
//             <IconButton
//               size="small"
//               color="primary"
//               onClick={() => setShowPassword2(!showPassword2)}
//               onMouseDown={handleMouseDownPassword}
//             >
//               {showPassword2 ? <VisibilityOff /> : <Visibility />}
//             </IconButton>
//           </InputAdornment>
//         ),
//       }}
//     />
//   </Box>
// </Grid>

//                   <Grid item xs={6} flexGrow={1} mx={'auto'}>
//                     <Box >
//                       <DyButton
//                         caption={'تایید'}
//                         color={'#00387C'}
//                         onClick={() => { }}
//                         disabled={addPassLoad  || !isValid || !dirty}
//                         variant={'contained'}
//                         bgColor={'#00387C'}
//                         type={'submit'}
//                       />
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Form>
//           }
//         </Formik>
//         break;
//     }
//   }

//   return (
//     <Grid container >
//       <Grid item xs={8} mx={'auto'}  >
//       <Box py={3} display={'flex'} justifyContent={'space-between'} alignItems={'center'} columnGap={2} >
//       <Typography variant='body1' fontWeight={600} >
//             {/* {
//               contentMessage
//             } */}
// لطفا اطلاعات مورد نیاز را وارد نمایید </Typography>
//           <LockResetIcon fontSize='large' />
//           <IconButton onClick={()=>{
//              setContentState({ content: 'login' })
//           }}   >
//         <ArrowForwardIcon/>  <Typography > برگشت </Typography>
//           </IconButton>
//         </Box>
//       </Grid>
//       <Grid item xs={12}   >
//         {
//           renderContent()
//         }
//       </Grid>
//       {
//        contentMessage  && <DYToastMessage
//       isSuccess={false}
//       message={contentMessage}
//       setShow={setShowToastMessage}
//       show={showToastMessage}
//        />
//     }

//     </Grid>
//   )
// }

// export default ResetPassword
